import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface KeyboardNavigationEvent {
  action: 'next' | 'previous' | 'select' | 'escape';
  index: number;
}

@Directive({
  selector: '[appKeyboardNavigation]'
})
export class KeyboardNavigationDirective {
  @Input() itemCount = 0;
  @Input() currentIndex = -1;
  @Output() navigationEvent = new EventEmitter<KeyboardNavigationEvent>();

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.itemCount === 0) return;

    switch (event.key) {
      case 'ArrowDown':
      case 'Down':
        { event.preventDefault();
        const nextIndex = Math.min(this.currentIndex + 1, this.itemCount - 1);
        this.navigationEvent.emit({ action: 'next', index: nextIndex });
        break; }

      case 'ArrowUp':
      case 'Up':
        { event.preventDefault();
        const prevIndex = Math.max(this.currentIndex - 1, -1);
        this.navigationEvent.emit({ action: 'previous', index: prevIndex });
        break; }

      case 'Enter':
        event.preventDefault();
        if (this.currentIndex >= 0 && this.currentIndex < this.itemCount) {
          this.navigationEvent.emit({ action: 'select', index: this.currentIndex });
        }
        break;

      case 'Escape':
      case 'Esc':
        event.preventDefault();
        this.navigationEvent.emit({ action: 'escape', index: -1 });
        break;

      case 'Tab':
        this.navigationEvent.emit({ action: 'escape', index: -1 });
        break;
    }
  }
}
